import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideFuse } from '@fuse';
import { provideTransloco, TranslocoService } from '@ngneat/transloco';
import { firstValueFrom,catchError } from 'rxjs';
import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { mockApiServices } from 'app/mock-api';
import { TranslocoHttpLoader } from './core/transloco/transloco.http-loader';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from './services/custom-toastr.service';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { AppComponent } from './app.component';
import { FileManagerComponent } from './modules/admin/apps/file-manager/file-manager.component';
import { LayoutComponent } from './layout/layout.component';
import { FileManagerListComponent } from './modules/admin/apps/file-manager/list/list.component';
import { LayoutWebComponent } from './layout/layouts/layout-web/layout-web.component';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { ShadowDomOverlayContainer } from './shared/custom-overlay-container';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ɵSharedStylesHost } from '@angular/platform-browser';
import { CustomStyleHost } from './shared/customStyleHost';

export const appConfigweb: ApplicationConfig = {
    providers: [
        {
            provide: ɵSharedStylesHost,
            useClass: CustomStyleHost,
        },

        {   
            provide: OverlayContainer,
            useClass: ShadowDomOverlayContainer
        },

        {
            provide: ToastrService,
            useClass: CustomToastrService,
        },

        provideLottieOptions({
            player: () => import('lottie-web'),
          }),

        provideLottieOptions({
            player: () => player,
          }),   
        provideAnimations(), // required animations providers


        importProvidersFrom(
            NgxLoadingModule.forRoot({
                // animationType: ngxLoadingAnimationTypes.wanderingCubes,
                // backdropBackgroundColour: "#00000021",
                 primaryColour: "#6349e2",
                secondaryColour: "#6349e2",
                tertiaryColour: "#6349e2",
                backdropBorderRadius: "3px",
            }),  
        ),
        provideAnimations(),
        provideHttpClient(),
         provideRouter(
            [
                { path: 'apps/file-manager', component : FileManagerListComponent},

             ],

            withPreloading(PreloadAllModules),
            withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
        ),

        // Material Date Adapter
        {
            provide : DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide : MAT_DATE_FORMATS,
            useValue: {
                parse  : {
                    dateInput: 'D',
                },
                display: {
                    dateInput         : 'DDD',
                    monthYearLabel    : 'LLL yyyy',
                    dateA11yLabel     : 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        provideTransloco({
            config: {
                availableLangs      : [
                    {
                        id   : 'en',
                        label: 'English',
                    },
                    {
                        id   : 'tr',
                        label: 'Turkish',
                    },
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : true,
            },
            loader: TranslocoHttpLoader,
        }),
        {
            provide: APP_INITIALIZER,
            useFactory: () => {
                const translocoService = inject(TranslocoService);
                const defaultLang = translocoService.getDefaultLang();
        
                // Ensure the language is set only if it's not already active
                if (!translocoService.getActiveLang()) {
                    translocoService.setActiveLang(defaultLang);
                }
        
                return () => {
                    return lastValueFrom(
                        translocoService.load(defaultLang).pipe(
                            catchError((error) => {
                                console.warn("Transloco already initialized or failed to load:", error);
                                return of(null); // Prevents breaking the app
                            })
                        )
                    ).then(() =>{
                        console.warn("Transloco already initialized")
                        return null;
                    }) // Ensures APP_INITIALIZER resolves successfully
                    .catch(() =>{
                        console.warn("Transloco already initialized or failed to load:");
                        return null
                    } );
                };
            },
            multi: true,
        },

        // Fuse
        provideAuth(),
        provideIcons(),
        provideFuse({
            mockApi: {
                delay   : 0,
                services: mockApiServices,
            },
            fuse   : {
                layout : 'modern',
                scheme : 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme  : 'theme-purple',
                themes : [
                    {
                        id  : 'theme-default',
                        name: 'Default',
                    },
                    {
                        id  : 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id  : 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id  : 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id  : 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id  : 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
    ],
};
function of(arg0: null): any {
    throw new Error('Function not implemented.');
}
